import { render, staticRenderFns } from "./orderErrDialog.vue?vue&type=template&id=069ee769&scoped=true&"
import script from "./orderErrDialog.vue?vue&type=script&lang=js&"
export * from "./orderErrDialog.vue?vue&type=script&lang=js&"
import style0 from "./orderErrDialog.vue?vue&type=style&index=0&id=069ee769&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "069ee769",
  null
  
)

export default component.exports